<!-- eslint-disable -->
<template lang="pug">
    div
        .title
            slot(name='title')
        form(action='javascript://', v-if='params')
            .form-container
                slot(name='multiplayer')
                template(v-if='!homework || homework.editable === undefined || (homework && (homework.editable || usersIds))')
                    .row(v-if="gameMode !== 'course' && slug !== 'AdditionAndSubtractionMathMagic'")
                        .form-container__column
                            label.form-container__label
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
                            .form-container__select
                                cs-multiselect(
                                    :multiple='false',
                                    :options='modes',
                                    label='label',
                                    :show-labels='false',
                                    :allow-empty='false',
                                    :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseMode')",
                                    :value="{label: $i18n.t('trainer')[params.mode], value: params.mode}",
                                    @select='selectMode'
                                )
                    .row
                        .form-container__column
                            label.form-container__label
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}
                            .form-container__select
                                cs-multiselect(
                                    :multiple='false',
                                    :options='difficult',
                                    :show-labels='false',
                                    :allow-empty='false',
                                    track-by='name',
                                    label='label',
                                    :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseDifficulty')",
                                    v-model='selectedDifficult',
                                    @select='difficultHandler'
                                )
                    .row(v-if="gameMode !== 'course'")
                        .form-container__column
                            label.form-container__label
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_combiningNumOfDigits') }}
                            cs-checkbox.form-container__select(
                                v-model="params.combining",
                                :checked='params && params.combining',
                                @change='combiningHandler',
                                :disabled='combiningDisabled'
                            )
                    div(v-if="params && params.combining")
                          combining-digit-capacity(
                              v-if='params.combining && !params.roundNumbers && !params.fractions',
                              :filtered-combining-digit-capacities='filteredCombiningDigitCapacities',
                              :combining-digit-capacities='params.combiningDigitCapacities',
                              :combining-digit-capacity-labels='combiningDigitCapacityLabels',
                              @changeCombiningDigitCapacities='changeCombiningDigitCapacities',
                          )
                .row(v-if="gameMode !== 'course'")
                    .form-container__column.form-container__column_fixed
                        label.form-container__label.form-container__label_fixed.input-label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfActions') }}
                        .form-container__select.form-container__select_short
                            cs-spin-input(
                                :value="params.amountOfActions",
                                :max="actions",
                                :min="2",
                                @increase="increaseActions",
                                @decrease="decreaseActions",
                                @input="params.amountOfActions = $event",
                            )
                .row(v-if="gameMode !== 'course'")
                    .form-container__column.form-container__column_fixed
                        label.form-container__label.form-container__label_fixed.input-label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
                        .form-container__select.form-container__select_short.form-container__select-examples
                            cs-spin-input(
                                :value="params.amountOfExamples",
                                :max="examples",
                                :min="1",
                                @increase="increaseExamples",
                                @decrease="decreaseExamples",
                                @input="params.amountOfExamples = $event",
                                :disabled="params && (params.infinityAmountOfExamples || !!params.timeLimit)"
                            )
                            .form-container__select-infinity-mode(v-if="gameMode && gameMode === 'free-game'")
                                cs-checkbox#infinityAmountOfExamples.form-container__checkbox(
                                    v-model="params.infinityAmountOfExamples"
                                    :checked="params && params.infinityAmountOfExamples"
                                    :disabled="params && (!!params.timeLimit || !!params.dictation)"
                                )
                                svg-icon.form-container__svg-icon(name="infinity" :aria-hidden="true" size="big")
                .row(v-if="gameMode !== 'course' && slug !== 'AdditionAndSubtractionWithTime' && !isGeneratorSettings")
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
                        .form-container__select
                            cs-multiselect(
                                v-model="selectedTimeLimit",
                                @select="timeLimitHandler"
                                :disabled="params.dictation",
                                :options="formattedTimeLimitValues",
                                :show-labels="false",
                                :allow-empty="false",
                                label="label",
                                track-by="amount",
                                :multiple="false",
                                :hide-selected="false",
                                :placeholder="$i18n.t('trainer.trainer_gameFormSetting_noSpecified')",
                                :searchable="false",
                            )
                .row(v-if="levelAnswerDuration && slug === 'AdditionAndSubtraction'")
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') }}
                        .form-container__select
                            cs-multiselect(
                                v-model='selectedAnswerDuration',
                                @select="answerDurationHandler",
                                label="label",
                                track-by="time",
                                :options="secondsInMinute",
                                :multiple="false",
                                :hide-selected="false",
                                :show-labels="false",
                                :allow-empty="false",
                                :placeholder="$i18n.t('trainer.trainer_gameFormSetting_noSpecified')",
                                :searchable="false",
                            )
                            help-text.add-sub-form__help-text(
                                v-if='showAnswerDurationHelpText',
                                slot='help-text',
                                v-text="$i18n.t('trainer.trainer_gameFormHelpText_emptyField')"
                            )
                .row(v-if="gameMode !== 'course' && slug !== 'AdditionAndSubtractionMathMagic'")
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_displaySpeed') }}
                        .form-container__select
                            cs-multiselect(
                                v-model='selectedSpeed',
                                @select="displaySpeedHandler",
                                label="label",
                                track-by="time",
                                :options="formattedSeconds",
                                :multiple="false",
                                :hide-selected="false",
                                :show-labels="false",
                                :allow-empty="false",
                                :placeholder="$i18n.t('trainer.trainer_gameFormSetting_noSpecified')",
                                :searchable="false",
                            )
                            help-text.add-sub-form__help-text(
                                v-if='slug === "AdditionAndSubtractionWithTime" && showDisplaySpeedHelpText',
                                slot='help-text',
                                v-text="$i18n.t('trainer.trainer_gameFormHelpText_tooHighSpeed')"
                            )
                template(v-if="gameMode !== 'course' && slug === 'AdditionAndSubtractionWithTime'")
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_speedIncreasing') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#isSpeedIncrease(
                                    v-model='params.isSpeedIncrease',
                                    :checked='params && params.isSpeedIncrease',
                                    :disabled="isSpeedIncreaseDisabled"
                                )
                    template(v-if='params.isSpeedIncrease')
                        .row
                            .form-container__column
                                label.form-container__label
                                    | {{ $i18n.t('trainer.trainer_gameFormSetting_exampleSpeedIncreasing') }}
                                .form-container__select
                                    cs-multiselect(
                                        v-model='params.tasksForSpeedUp',
                                        :options="tasksForSpeedUpOptions"
                                        :multiple="false",
                                        :show-labels="false",
                                        :allow-empty="false",
                                        placeholder=""
                                        :searchable="false",
                                    )
                        .row
                            .form-container__column
                                label.form-container__label
                                    | {{ $i18n.t('trainer.trainer_gameFormSetting_speedIncreasingOn') }}
                                .form-container__select
                                    cs-multiselect(
                                        v-model='selectedSpeedUp',
                                        @select="speedUpHandler",
                                        :options="secondsForSpeedUp",
                                        track-by="time",
                                        label="label",
                                        :allow-empty="false",
                                        placeholder="",
                                        :multiple="false",
                                        :show-labels="false",
                                        :searchable="false",
                                    )
                                    help-text.add-sub-form__help-text(
                                        v-if='showDisplaySpeedIncreasingHelpText',
                                        slot='help-text',
                                        v-text="$i18n.t('trainer.trainer_gameFormHelpText_voiceOverWillDisableAfter') + showDisplaySpeedIncreasingHelpText + ' ' + $i18n.tc('trainer.trainer_gamePreview_exampleDeclination', showDisplaySpeedIncreasingHelpText)"
                                    )
                        .row
                            .form-container__column.form-container__column_fixed
                                label.form-container__label.form-container__label_fixed
                                    | {{ $i18n.t('trainer.trainer_gameFormSetting_minimalSpeed') }}
                                .form-container__select.form-container__select_spaced
                                    cs-checkbox#isMinimalSpeed(v-model='params.isMinimalSpeed', :checked="params && params.isMinimalSpeed")
                template(v-if="gameMode !== 'course' && slug !== 'AdditionAndSubtractionMathMagic'")
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_exampleComplication') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox(
                                    v-model='params.isComplication',
                                    :checked="params && params.isComplication",
                                    :disabled="isComplicationDisabled"
                                )
                    template(v-if='params.isComplication')
                        .row
                            .form-container__column
                                label.form-container__label
                                    | {{ $i18n.t('trainer.trainer_gameFormSetting_examplesToComplicate') }}
                                .form-container__select
                                    cs-multiselect(
                                        v-model='params.tasksForComplication',
                                        :options="availableTasksForComplication",
                                        :multiple="false",
                                        :show-labels="false",
                                        :allow-empty="false",
                                        placeholder="",
                                        :searchable="false",
                                    )
                        .row
                            .form-container__column
                                label.form-container__label
                                    | {{ $i18n.t('trainer.trainer_gameFormSetting_complicationOfActions') }}
                                .form-container__select
                                    cs-multiselect(
                                        v-model='params.complication',
                                        :options="complicationOptions",
                                        :searchable="false",
                                        :multiple="false",
                                        :show-labels="false",
                                        :allow-empty="false",
                                    )
                .row(v-if="gameMode === 'free-game'")
                    .form-container__column.form-container__column_fixed
                        label.form-container__label.form-container__label_fixed
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_dictation') }}
                        .form-container__select.form-container__select_spaced
                            cs-checkbox#dictation(v-model='params.dictation', :checked="params && params.dictation", :disabled="isMultiplayer")
                .row(v-if='params.dictation')
                    .form-container__column
                        label.form-container__label
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') }}
                        .form-container__select
                            cs-multiselect(
                                v-model='selectedTimeForAnswer',
                                :options="dictationSeconds",
                                @select="timeForAnswerHandler",
                                track-by="time",
                                label="label",
                                :multiple="false",
                                :allow-empty="false",
                                :show-labels="false",
                                :searchable="false",
                            )
                template(v-if="gameMode !== 'course' && slug !== 'AdditionAndSubtractionMathMagic'")
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#fractions(
                                    :checked='params && params.fractions',
                                    @change='fractionsHandler',
                                    :disabled="(params.roundNumbers || params.mirror)"
                                )
                    .row(v-if='params.fractions')
                        .form-container__column
                            label.form-container__label
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints') }}
                            .form-container__select
                                cs-multiselect(
                                    v-model='params.fractionalPart',
                                    :options="fractionalPart",
                                    :multiple="false",
                                    :searchable="false",
                                    :allow-empty="false",
                                    :show-labels="false",
                                )
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_mirror') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#mirror(
                                    v-model='params.mirror',
                                    :checked="params && params.mirror",
                                    :disabled="(params.difficult === 'Однозначные цифры' || params.fractions || params.roundNumbers)"
                                )
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_roundNumbers') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#round-numbers(
                                    v-model="params.roundNumbers",
                                    :checked='params && params.roundNumbers',
                                    @change='roundNumbersHandler'
                                    :disabled="(params.difficult === 'Однозначные цифры' || params.fractions || params.mirror)"
                                )
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_positiveAnswers') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#positiveAnswers(
                                    v-model='params.positiveAnswers',
                                    :checked="params && params.positiveAnswers",
                                    :disabled="positiveAnswersDisabled"
                                )
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_negativeAnswers') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#negativeAnswers(
                                    v-model='params.negativeAnswers',
                                    :checked='params && params.negativeAnswers',
                                    :disabled="negativeAnswersDisabled"
                                )
                    .row
                        .form-container__column.form-container__column_fixed
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_interimAnswers') }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox#interimAnswers(
                                    v-model='params.interimAnswers',
                                    :checked='params && params.interimAnswers',
                                    :disabled="interimAnswersDisabled"
                                )
                    .row
                        .form-container__column.form-container__column_fixed(
                            v-for="x in stayInOptions"
                            v-if="isStayInXAvailable(x)"
                        )
                            label.form-container__label.form-container__label_fixed
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_stayIn', {x}) }}
                            .form-container__select.form-container__select_spaced
                                cs-checkbox(
                                    v-model="params.stayIn",
                                    :checked="params && params.stayIn",
                                    :disabled="!isStayInXAvailable(x)"
                                )
            divider(v-if="slug !== 'AdditionAndSubtractionMathMagic'")
            .form-container
                .settings
                    template(v-if="slug !== 'AdditionAndSubtractionMathMagic'")
                        .row
                            .settings-header
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_simple') }}
                            .form-container__settings
                                template(v-for='number in 9')
                                    cs-checkbox.setting__checkbox(
                                        @click.native.prevent="setNumber(number, 'simple')",
                                        :checked="params && params.simple.includes(number)"
                                        :key="'simple' + number",
                                        :disabled="isDisabledSimple('simple', number)"
                                    ) {{ number }}
                            .form-container__settings
                                cs-checkbox(
                                    :checked="checkedSelectedItems('simple')"
                                    @change="selectAllForGroup('simple')"
                                    :disabled="simpleDisabled"
                                )
                                    | {{ $i18n.t('trainer.trainer_gameFormSetting_selectAll') }}
                        .row
                            .settings-header
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_brothers') }}
                            .form-container__settings
                                template(v-for="(number, index) in 4")
                                    cs-checkbox.setting__checkbox(
                                        :key="'brothers' + (5 - number)",
                                        :checked="params.brothers.includes(5 - number)",
                                        @change="setNumber(5 - number, 'brothers')",
                                        :disabled="isDisabledBrothers('brothers', 5 - number)"
                                    ) {{ 5 - number }}
                            .form-container__settings
                                cs-checkbox(
                                    :checked="checkedSelectedItems('brothers')"
                                    @change="selectAllForGroup('brothers')"
                                    :disabled="brothers.length == 0"
                                )
                                    | {{ $i18n.t('trainer.trainer_gameFormSetting_selectAll') }}
                            .form-container__settings(v-if="gameMode !== 'course'")
                                cs-checkbox.setting__checkbox(
                                    v-model='params.brothersOptions.onlyAddition',
                                    :disabled='areBrothersOnlyOptionsDisabled'
                                ) {{ $i18n.t('trainer.trainer_gameFormSetting_onlyAddition') }}
                                cs-checkbox.setting__checkbox(
                                    v-model='params.brothersOptions.onlySubtraction',
                                    :disabled='areBrothersOnlyOptionsDisabled'
                                ) {{ $i18n.t('trainer.trainer_gameFormSetting_onlySubtraction') }}
                        .row
                            .settings-header
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_friends') }}
                            .form-container__settings
                                cs-checkbox.setting__checkbox(
                                    v-for="(number, index) in 9",
                                    :key="'friends' + (10 - number)",
                                    :checked="params.friends.includes(10 - number)",
                                    @change="setNumber(10 - number, 'friends')"
                                    :disabled="isDisabledFriends('friends', 10 - number, index)"
                                ) {{ 10 - number }}
                            .form-container__settings
                                cs-checkbox(
                                    :checked="checkedSelectedItems('friends')"
                                    @change="selectAllForGroup('friends')"
                                    :disabled="friends.length == 0"
                                )
                                    | {{ $i18n.t('trainer.trainer_gameFormSetting_selectAll') }}
                            .form-container__settings(v-if="gameMode !== 'course'")
                                cs-checkbox.setting__checkbox(
                                    v-model='params.friendsOptions.onlyAddition',
                                    :disabled='areFriendsOnlyOptionsDisabled'
                                ) {{ $i18n.t('trainer.trainer_gameFormSetting_onlyAddition') }}
                                cs-checkbox.setting__checkbox(
                                    v-model='params.friendsOptions.onlySubtraction',
                                    :disabled='areFriendsOnlyOptionsDisabled'
                                ) {{ $i18n.t('trainer.trainer_gameFormSetting_onlySubtraction') }}
                                help-text.add-sub-form__help-text(
                                    v-if='showNegativeAnswersHelpText',
                                    slot='help-text',
                                    v-text="$i18n.t('trainer.trainer_gameFormHelpText_selectMoreOptions')"
                                )
                        .row
                            .settings-header
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_brothersAndFriends') }}
                            .form-container__settings
                                span(v-for='(number, index) in 4')
                                    cs-checkbox.setting__checkbox(
                                        :key="'friends&brothers' + (5 + number)",
                                        :checked="params && params.brothersAndFriends.includes(5 + number)",
                                        @change="setNumber(5 + number, 'brothersAndFriends')"
                                        :disabled="isDisabledBrothersAndFriends('brothersAndFriends', 5 + number)"
                                    ) {{ 5 + number }}
                            .form-container__settings
                                cs-checkbox(
                                    :checked="checkedSelectedItems('brothersAndFriends')"
                                    @change="selectAllForGroup('brothersAndFriends')"
                                    :disabled="brothersAndFriends.length == 0"
                                )
                                    | {{ $i18n.t('trainer.trainer_gameFormSetting_selectAll') }}
                            .form-container__settings(v-if="gameMode !== 'course'")
                                cs-checkbox.setting__checkbox(
                                    v-model='params.brothersAndFriendsOptions.onlyAddition',
                                    :disabled='areBrothersAndFriendsOnlyOptionsDisabled'
                                ) {{ $i18n.t('trainer.trainer_gameFormSetting_onlyAddition') }}
                                cs-checkbox.setting__checkbox(
                                    v-model='params.brothersAndFriendsOptions.onlySubtraction',
                                    :disabled='areBrothersAndFriendsOnlyOptionsDisabled'
                                ) {{ $i18n.t('trainer.trainer_gameFormSetting_onlySubtraction') }}
                                help-text.add-sub-form__help-text(
                                    v-if='showNegativeAnswersHelpText',
                                    slot='help-text',
                                    v-text="$i18n.t('trainer.trainer_gameFormHelpText_selectMoreOptions')"
                                )
                        .row
                            .form-container__column
                                label.form-container__label.form-container__transition-through
                                    | {{ $i18n.t('trainer.trainer_gameFormSetting_transitionThrough') }}
                                .form-container__select
                                    cs-multiselect(
                                        :options='jumpOver',
                                        :show-labels='false',
                                        :allow-empty='true',
                                        :multiple="gameMode === 'course'",
                                        :hide-selected="gameMode === 'course'",
                                        track-by='value',
                                        label='value',
                                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_noSpecified')",
                                        :disabled='!isAllowJumpOver',
                                        v-model='params.jumpOver'
                                    )
                    template(v-if="slug !== 'AdditionAndSubtractionWithTime'")
                        divider
                        .row
                            .form-container__settings
                                cs-checkbox(
                                    v-model="isShowExampleInTheLine || params.showExampleInTheLine",
                                    :checked="isShowExampleInTheLine || params.showExampleInTheLine"
                                )
                                    | {{ $i18n.t('trainer.trainer_gameFormSetting_exampleInTheLine') }}
                    template(v-if="playersNumber > 1 || slug === 'AdditionAndSubtractionWithTime'")
                        .row
                            .form-container__settings
                                cs-checkbox(
                                    v-model="params.showAnswer",
                                    :checked="params.showAnswer"
                                )
                                    | {{ $i18n.t('trainer.trainer_gameFormSetting_showAnswer') }}
                    template(v-if="slug === 'AdditionAndSubtractionWithTime' && gameMode !== 'course'")
                        .settings-header
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_addParams') }}
                        .row
                            .form-container__settings
                                cs-checkbox#pictures(
                                    v-model='params.extraOptions.pictures',
                                    :checked="params && params.extraOptions.pictures",
                                    :disabled="!isPicturesAvailable"
                                ) {{ $i18n.t('trainer.trainer_gameFormSetting_distractingPictures') }}
                            .form-container__settings
                                cs-checkbox#music(
                                    v-model='params.extraOptions.music',
                                    :checked="params && params.extraOptions.music",
                                    :disabled="!isMusicAvailable"
                                ) {{ $i18n.t('trainer.trainer_gameFormSetting_music') }}
                            .form-container__settings
                                cs-checkbox#x2(
                                    v-model='params.extraOptions.x2',
                                    :checked="params && params.extraOptions.x2",
                                    :disabled="!isX2Available"
                                ) {{ $i18n.t('trainer.trainer_gameFormSetting_x2') }}
                            .form-container__settings
                                cs-checkbox#motion(
                                    v-model='params.extraOptions.motion',
                                    :checked="params && params.extraOptions.motion",
                                    :disabled="!isMotionAvailable"
                                ) {{ $i18n.t('trainer.trainer_gameFormSetting_movement', {element: $i18n.t('trainer.trainer_gameFormSettingValue_numbers')}) }}
                            .form-container__settings
                                cs-checkbox#voice-over(
                                    v-model='params.extraOptions.voiceOver',
                                    :checked="params && params.extraOptions.voiceOver",
                                    :disabled="!isVoiceOverAvailable"
                                ) {{ $i18n.t('trainer.trainer_gameFormSetting_voiceActing') }}
                slot(name='parameters')
                .help-text
                    slot(name='help')
                template(v-if='!usersIds')
                    .form-container__footer-buttons
                        cs-button.cancel-button(type='button', @click='cancel', pattern="primary-outline", color="blue")
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                        template(v-if="gameMode && gameMode === 'free-game'")
                            cs-button.save-button(
                                :disabled="showNegativeAnswersHelpText"
                                type='button',
                                @click='saveGameMode',
                                color="blue"
                            )
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                        template(v-else)
                            cs-button.save-button(
                                :disabled="showNegativeAnswersHelpText"
                                type='button',
                                @click='saveGame',
                                color="blue"
                            )
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else)
                    .form-container__footer-buttons
                        cs-button.cancel-button(type='button', @click='cancel', pattern="primary-outline", color="blue")
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                        cs-button.save-button(
                            :disabled="showNegativeAnswersHelpText"
                            type='button',
                            color="blue",
                            @click='saveGame'
                        )
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    /*eslint-disable*/
    import _ from 'lodash';
    import { mapState } from 'vuex';
    import TrainerGames from '../../../config/trainer';
    import AddSubConfig from '../../trainer/configs/AddSubConfig';
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import { getInitParameters } from '../../../utils/trainer/getInitParameters';
    const DEFAULT_TIME_LIMIT = 0;
    const DISABLED_VOICE_DIFFICULTIES = [
        'Четырехзначные цифры',
        'Пятизначные цифры',
        'Шестизначные цифры',
        'Семизначные цифры',
        'Восьмизначные цифры',
    ];
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';
    import disableDictationForMultiplayer from '../../../utils/multiplayer/disableDictationForMultiplayer';
    import speedHelpTextMixin from '../utils/speedHelpTextMixin';
    import combiningCapacitiesMixin from '../utils/combiningCapacitiesMixin';

    import CombiningDigitCapacity from '../shared/CombiningDigitCapacity.vue';

    export default {
        components: {
            CombiningDigitCapacity,
        },
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex',
        ],
        data() {
            return {
                modes: [
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbacus'),
                        value: 'На счетах',
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_inMind'),
                        value: 'В уме',
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_any'),
                        value: 'Любой',
                    },
                ],
                simple: AddSubConfig.digits,
                brothers: [4, 3, 2, 1],
                friends: [9, 8, 7, 6, 5, 4, 3, 2, 1],
                brothersAndFriends: [6, 7, 8, 9],
                seconds: AddSubConfig.seconds,
                timeLimitValues: AddSubConfig.timeLimitValues,
                params: null,
                selectedDifficult: null,
                jumpOver: [{ value: 50 }, { value: 100 }],
                stayInOptions: [100, 1000],
                examples: 100,
                selectedTimeLimit: null,
                secondsInMinute: [...Array(61).keys()].slice(1).map(time => {
                    return {
                        time: time,
                        label: `${time} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds'),
                    };
                }),
                dictationSeconds: [...Array(101).keys()].slice(1).map(time => {
                    return {
                        time: time,
                        label: `${time} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds'),
                    };
                }),
                selectedAnswerDuration: null,
                selectedSpeed: null,
                selectedSpeedUp: null,
                selectedTimeForAnswer: null,
                fractionalPart: [...Array(3).keys()].slice(1),
                isShowExampleInTheLine: false,
            };
        },
        mixins: [
            GameFormMixin,
            multiplayerFormMixin,
            speedHelpTextMixin,
            combiningCapacitiesMixin,
            disableDictationForMultiplayer,
        ],
        mounted() {
            if (this.isGeneratorSettings) {
                if (this.homework && this.homework.grades && this.homework.grades.length) {
                    let currentGameSettings = this.homework.grades[0].course.games.find(
                        element => element.slug == this.slug
                    );
                    this.gamesParameters[this.slug] = currentGameSettings.parameters.default;
                }
                if (this.homework && this.homework.courses) {
                    let copyCourses = this.homework.courses.filter(course =>
                        course.games.find(element => element.slug == this.slug)
                    );
                    copyCourses.sort((a, b) => a.level - b.level);
                    let currentGameSettings = copyCourses[0].games.find(element => element.slug == this.slug);
                    this.gamesParameters[this.slug] = currentGameSettings.parameters.default;
                }
                this.brothersAndFriends = this.gamesParameters[this.slug].brothersAndFriends;
                this.brothers = this.gamesParameters[this.slug].brothers;
                this.friends = this.gamesParameters[this.slug].friends;
                this.simple = this.gamesParameters[this.slug].simple;
                this.isShowExampleInTheLine = this.gamesParameters[this.slug].showExampleInTheLine;
            }
            if (this.gameMode === 'free-game') {
                if (this.gamesParameters) {
                    this.params = getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: _.cloneDeep(this.gamesParameters[this.slug]),
                        },
                    });
                    let difficultIndex = this.difficult
                        .map(difficulty => difficulty.name)
                        .indexOf(this.gamesParameters[this.slug].difficult);
                    for (let i = difficultIndex + 1; i < this.difficult.length; i++) {
                        this.difficult[i].$isDisabled = true;
                    }
                    this.jumpOver.forEach(setting => {
                        setting.$isDisabled = !_.some(
                            this.gamesParameters[this.slug].jumpOver,
                            elem => elem.value === setting.value
                        );
                    });
                    this.brothersAndFriends = this.gamesParameters[this.slug].brothersAndFriends;
                    this.friends = this.gamesParameters[this.slug].friends;
                    this.brothers = this.gamesParameters[this.slug].brothers;
                }
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else {
                    _.cloneDeep(TrainerGames.games).forEach(item => {
                        if (item.slug === this.slug) {
                            this.params = item.parameters.default;
                        }
                    });
                }
                this.selectedDifficult = _.find(this.difficult, { name: this.params.difficult });
                this.selectedTimeLimit = this.formattedTimeLimitValues.find(
                    value => value.amount === this.params.timeLimit
                );
                this.selectedAnswerDuration = this.secondsInMinute.find(
                    value => value.time === this.params.answerDuration
                );
                this.selectedSpeed = this.formattedSeconds.find(value => value.time === this.params.speed);
                this.selectedSpeedUp = this.secondsForSpeedUp.find(value => value.time === this.params.speedUp);
                this.selectedTimeForAnswer = this.dictationSeconds.find(
                    value => value.time === this.params.timeForAnswer
                );
                this.params.infinityAmountOfExamples = true;
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
        },
        watch: {
            isAllowJumpOver(val) {
                if (!val) {
                    this.params.jumpOver = null;
                }
            },
            'params.extraOptions.x2': {
                handler(val) {
                    this.gameMode !== 'course' && val && (this.params.extraOptions.motion = false);
                },
            },
            'params.extraOptions.motion': {
                handler(val) {
                    this.gameMode !== 'course' && val && (this.params.extraOptions.x2 = false);
                },
            },
            'params.negativeAnswers'(val) {
                if (val) {
                    // this.setNumber(1, 'friends')
                    this.params.simple = this.simple;
                    this.params.brothers = this.brothers;
                }
            },
            combiningDisabled(val) {
                if (val) {
                    this.params.combining = false;
                }
            },
            'params.friends.length'(length) {
                length === 0 && (this.params.jumpOver = null);
            },
            'params.speed'() {
                if (
                    this.params.speedUp >= this.params.speed &&
                    this.secondsForSpeedUp[this.secondsForSpeedUp.length - 1]
                ) {
                    this.params.speedUp = this.secondsForSpeedUp[this.secondsForSpeedUp.length - 1].time;
                }
            },
            'params.jumpOver'(val) {
                if (val) {
                    this.params.stayIn = false;
                    this.params.interimAnswers = false;
                    this.params.simple = this.simple;
                    this.params.brothers = this.brothers;
                    if (!this.params.friends?.length && !this.params.brothersAndFriends?.length) {
                        this.setNumber(9, 'friends');
                    }
                }
            },
            'params.stayIn'(val) {
                if (val) {
                    this.params.interimAnswers = false;
                }
            },
            'params.interimAnswers'(val) {
                if (val) {
                    this.params.simple = this.simple;
                    this.params.brothers = this.brothers;
                    this.params.friends = this.friends;
                    this.params.brothersAndFriends = this.brothersAndFriends;
                }
            },
            'params.amountOfExamples'(val) {
                if (this.params.tasksForSpeedUp >= this.params.amountOfExamples && this.params.amountOfExamples !== 1) {
                    this.params.tasksForSpeedUp = this.params.amountOfExamples - 1;
                }
                if (this.params.timeLimit) {
                    this.params.tasksForComplication = 1;
                } else if (this.params.tasksForComplication >= val && val !== 1) {
                    this.params.tasksForComplication = val - 1;
                }
                if (val) {
                    this.params.timeLimit = DEFAULT_TIME_LIMIT;
                }
            },
            'params.amountOfActions'(val) {
                let maxActions = 0;
                if (this.slug === 'AdditionAndSubtractionWithTime') {
                    maxActions = 100;
                }
                if (this.slug === 'AdditionAndSubtraction') {
                    maxActions = 15;
                }
                if (this.params.complication + this.params.amountOfActions > maxActions) {
                    this.params.complication = maxActions - this.params.amountOfActions;
                }
                if (this.params.amountOfActions === maxActions) {
                    this.params.complication = 1;
                }
            },
            'params.timeLimit'(val) {
                if (val) {
                    this.params.amountOfExamples = false;
                } else {
                    if (!this.params.amountOfExamples) {
                        this.params.amountOfExamples = 1;
                    }
                }
            },
            'params.friendsOptions.onlyAddition'(val) {
                if (val) {
                    this.params.friendsOptions.onlySubtraction = false;
                }
            },
            'params.friendsOptions.onlySubtraction'(val) {
                if (val) {
                    this.params.friendsOptions.onlyAddition = false;
                }
            },
            'params.brothersOptions.onlyAddition'(val) {
                if (val) {
                    this.params.brothersOptions.onlySubtraction = false;
                }
            },
            'params.brothersOptions.onlySubtraction'(val) {
                if (val) {
                    this.params.brothersOptions.onlyAddition = false;
                }
            },
            'params.brothersAndFriendsOptions.onlyAddition'(val) {
                if (val) {
                    this.params.brothersAndFriendsOptions.onlySubtraction = false;
                }
            },
            'params.brothersAndFriendsOptions.onlySubtraction'(val) {
                if (val) {
                    this.params.brothersAndFriendsOptions.onlyAddition = false;
                }
            },
            'params.mirror'(val) {
                if (val) {
                    this.params.jumpOver = null;
                }
            },
            'params.dictation'(val) {
                if (val) {
                    this.params.extraOptions && (this.params.extraOptions.x2 = false);
                    this.params.timeLimit = 0;
                    this.params.infinityAmountOfExamples = false;
                }
            },
            areBrothersOnlyOptionsDisabled(val) {
                if (val && this.params.brothersOptions) {
                    this.params.brothersOptions.onlyAddition = false;
                    this.params.brothersOptions.onlySubtraction = false;
                }
            },
            areFriendsOnlyOptionsDisabled(val) {
                if (val && this.params.friendsOptions) {
                    this.params.friendsOptions.onlyAddition = false;
                    this.params.friendsOptions.onlySubtraction = false;
                }
            },
            areBrothersAndFriendsOnlyOptionsDisabled(val) {
                if (val && this.params.brothersAndFriendsOptions) {
                    this.params.brothersAndFriendsOptions.onlyAddition = false;
                    this.params.brothersAndFriendsOptions.onlySubtraction = false;
                }
            },
            isVoiceOverAvailable(val) {
                !val && (this.params.extraOptions.voiceOver = val);
            },
        },
        methods: {
            isDisabledSimple(type, number) {
                if (this.simpleDisabled) return true;

                if (this.slug === 'AdditionAndSubtractionWithTime') {
                  return this.isDisableCheckbox(type, number) || this.isSimpleDisabled(number);
                }

                return (
                    this.isDisableCheckbox(type, number) || (!this.isGeneratorSettings && this.isSimpleDisabled(number))
                );
            },
            isDisabledFriends(type, number, index = '') {
                return (
                    this.isDisableCheckbox(type, number) ||
                    (!this.isGeneratorSettings &&
                        (!this.friends.find(elem => elem == number) || this.isOnlyJumpOverSetting(number, type)))
                );
            },
            isDisabledBrothers(type, number) {
                return (
                    this.isDisableCheckbox(type, number) ||
                    (!this.isGeneratorSettings && !this.brothers.find(elem => elem == number))
                );
            },
            isDisabledBrothersAndFriends(type, number) {
                return (
                    this.isDisableCheckbox(type, number) ||
                    (!this.isGeneratorSettings &&
                        (!this.brothersAndFriends.find(elem => elem == number) ||
                            this.isOnlyJumpOverSetting(number, type) ||
                            this.brothersAndFriendsDisabled))
                );
            },
            isDisableCheckbox(method, id) {
                if (this.isGeneratorSettings) {
                    switch (method) {
                        case 'brothersAndFriends':
                            if (!this.gamesParameters[this.slug].brothersAndFriends.find(element => element == id)) {
                                return true;
                            }
                            break;
                        case 'friends':
                            if (!this.gamesParameters[this.slug].friends.find(element => element == id)) {
                                return true;
                            }
                            break;
                        case 'brothers':
                            if (!this.gamesParameters[this.slug].brothers.find(element => element == id)) {
                                return true;
                            }
                            break;
                        case 'simple':
                            if (!this.gamesParameters[this.slug].simple.find(element => element == id)) {
                                return true;
                            }
                            break;
                    }
                }
                return false;
            },
            difficultHandler(difficult) {
                difficult = difficult.name;
                this.params.difficult = difficult;
                if (
                    (difficult !== 'Двузначные цифры' &&
                        difficult !== 'Трехзначные цифры' &&
                        this.gameMode !== 'course') ||
                    difficult === 'Однозначные цифры'
                ) {
                    this.params.jumpOver = null;
                }
                if (difficult === 'Однозначные цифры') {
                    this.params.mirror = false;
                    this.params.roundNumbers = false;
                }
                if (this.stayInOptions.every(option => !this.isStayInXAvailable(option))) {
                    this.params.stayIn = false;
                }
                if (this.params.combining) {
                    this.fillCombiningDigitCapacities();
                }
                if (this.combiningDisabled) {
                    this.params.combiningDigitCapacities = [];
                }
            },
            timeLimitHandler(value) {
                this.params.timeLimit = value.amount;
            },
            answerDurationHandler(value) {
                this.params.answerDuration = value.time;
            },
            displaySpeedHandler(value) {
                this.params.speed = value.time;
            },
            speedUpHandler(value) {
                this.params.speedUp = value.time;
            },
            timeForAnswerHandler(value) {
                this.params.timeForAnswer = value.time;
            },
            combiningHandler(combining) {
                this.params.combining = combining;
                if (combining && this.gameMode !== 'course') {
                    this.params.jumpOver = null;
                }
                this.params.combiningDigitCapacities = [];
                if (combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            roundNumbersHandler(event) {
                let value = event;
                this.params.roundNumbers = value;
                if (value) {
                    this.params.jumpOver = null;
                }
                if (this.params.combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            fractionsHandler() {
                this.params.fractions = !this.params.fractions;
                if (this.params.fractions) {
                    this.params.mirror = false;
                    this.params.roundNumbers = false;
                    this.params.jumpOver = null;
                }
                if (this.params.fractions && this.params.combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            setNumber(number, type) {
                if (type !== 'simple') {
                    this.params.simple = this.simple;
                }
                if (this.params[type].includes(number)) {
                    this.params[type] = this.params[type].filter(value => value !== number);
                } else {
                    this.params[type].push(number);
                }
            },
            selectMode(mode) {
                this.params.mode = mode.value;
            },
            decreaseActions() {
                if (this.params.amountOfActions !== 2) {
                    this.params.amountOfActions -= 1;
                }
            },
            increaseActions() {
                if (this.params.amountOfActions !== this.actions) {
                    this.params.amountOfActions += 1;
                }
            },
            decreaseExamples() {
                if (
                    this.params.amountOfExamples !== 1 &&
                    !this.params.timeLimit &&
                    !this.params.infinityAmountOfExamples
                ) {
                    this.params.amountOfExamples -= 1;
                }
            },
            increaseExamples() {
                if (
                    this.params.amountOfExamples !== this.examples &&
                    !this.params.timeLimit &&
                    !this.params.infinityAmountOfExamples
                ) {
                    this.params.amountOfExamples += 1;
                }
            },
            isSimpleDisabled(number) {
                return (
                    this.simpleDisabled ||
                    (this.gamesParameters && !this.gamesParameters[this.slug]?.simple[number - 1]) ||
                    (this.params.simple.filter(value => value <= 2).length === 1 &&
                        number <= 2 &&
                        this.params.simple.includes(number))
                );
            },
            isFriendsDisabled(index) {
                return (
                    this.friendsDisabled || (this.gamesParameters && !this.gamesParameters[this.slug]?.friends[index])
                );
            },
            isBrothersAndFriendsDisabled(index) {
                return (
                    this.brothersAndFriendsDisabled ||
                    (this.gamesParameters && !this.gamesParameters[this.slug]?.brothersAndFriends[index])
                );
            },
            isOnlyJumpOverSetting(number, type) {
                const oppositeType = type === 'friends' ? 'brothersAndFriends' : 'friends';
                return (
                    !!this.params.jumpOver &&
                    this.params[type].includes(number) &&
                    this.params[type].length === 1 &&
                    !this.params[oppositeType].length
                );
            },
            checkedSelectedItems(type) {
                switch (type) {
                    case 'simple':
                        return this.params.simple.length === this.simple.length && this.simple.length > 0;
                    case 'brothers':
                        return this.params.brothers.length === this.brothers.length && this.brothers.length > 0;
                    case 'friends':
                        return this.params.friends.length === this.friends.length && this.friends.length > 0;
                    case 'brothersAndFriends':
                        return (
                            this.params.brothersAndFriends.length === this.brothersAndFriends.length &&
                            this.brothersAndFriends.length > 0
                        );
                }
            },
            selectAllForGroup(type) {
                switch (type) {
                    case 'simple':
                        if (this.params.simple.length !== this.simple.length || this.params.simple.length === 0) {
                            this.params.simple = _.cloneDeep(this.simple);
                        } else {
                            this.params.simple = [1];
                        }
                        break;
                    case 'brothers':
                        if (this.params.brothers.length !== this.brothers.length || this.params.brothers.length === 0) {
                            this.params.brothers = _.cloneDeep(this.brothers);
                            if (type !== 'simple') {
                                this.params.simple = this.simple;
                            }
                        } else {
                            this.params.brothers = [];
                        }
                        break;
                    case 'friends':
                        if (this.params.friends.length !== this.friends.length || this.params.friends.length === 0) {
                            this.params.friends = _.cloneDeep(this.friends);
                            if (type !== 'simple') {
                                this.params.simple = this.simple;
                            }
                        } else {
                            this.params.friends = [];
                        }
                        break;
                    case 'brothersAndFriends':
                        if (
                            this.params.brothersAndFriends.length !== this.brothersAndFriends.length ||
                            this.params.brothersAndFriends.length === 0
                        ) {
                            this.params.brothersAndFriends = _.cloneDeep(this.brothersAndFriends);
                            if (type !== 'simple') {
                                this.params.simple = this.simple;
                            }
                        } else {
                            this.params.brothersAndFriends = [];
                        }
                }
            },
            isStayInXAvailable(x) {
                return this['stayIn' + x + 'Available'];
            },
        },
        updated() {
            this.selectedDifficult = _.find(this.difficult, { name: this.params.difficult });
            this.selectedTimeLimit = this.formattedTimeLimitValues.find(
                value => value.amount === this.params.timeLimit
            );
            this.selectedAnswerDuration = this.secondsInMinute.find(value => value.time === this.params.answerDuration);
            this.selectedSpeed = this.formattedSeconds.find(value => value.time === this.params.speed);
            this.selectedSpeedUp = this.secondsForSpeedUp.find(value => value.time === this.params.speedUp);
            this.selectedTimeForAnswer = this.dictationSeconds.find(value => value.time === this.params.timeForAnswer);
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
            isGeneratorSettings() {
                if (this.gameMode == 'generator-settings' && this.gamesParameters) {
                    return true;
                }
                return false;
            },
            isOnlyCheckboxForBrothersAndFriends() {
                if (this.isGeneratorSettings && this.gamesParameters[this.slug].brothersAndFriends.length > 0) {
                    return true;
                }
                return false;
            },
            difficult() {
                let commonDifficult = [
                    {
                        label: this.$i18n.t('common.common_gameSetting_singleDigitNum'),
                        name: 'Однозначные цифры',
                        $isDisabled: false,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_doubleDigitsNum'),
                        name: 'Двузначные цифры',
                        $isDisabled: false,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_tripleDigitsNum'),
                        name: 'Трехзначные цифры',
                        $isDisabled: false,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fourDigitsNum'),
                        name: 'Четырехзначные цифры',
                        $isDisabled: false,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fiveDigitsNum'),
                        name: 'Пятизначные цифры',
                        $isDisabled: false,
                    },
                ];
                let extraDifficult = [
                    {
                        label: this.$i18n.t('common.common_gameSetting_sixDigitsNum'),
                        name: 'Шестизначные цифры',
                        $isDisabled: false,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_sevenDigitsNum'),
                        name: 'Семизначные цифры',
                        $isDisabled: true,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_eightDigitsNum'),
                        name: 'Восьмизначные цифры',
                        $isDisabled: true,
                    },
                ];
                if (this.slug === 'AdditionAndSubtractionMathMagic') {
                    return commonDifficult;
                }
                return [...commonDifficult, ...extraDifficult];
            },
            simpleDisabled() {
                return (
                    !!this.params.brothers?.length ||
                    !!this.params.friends?.length ||
                    !!this.params.brothersAndFriends?.length ||
                    this.params.negativeAnswers ||
                    this.params.interimAnswers
                );
            },
            brothersDisabled() {
                return this.params.negativeAnswers || !!this.params.interimAnswers || !!this.params.jumpOver;
            },
            friendsDisabled() {
                return !!this.params.interimAnswers;
            },
            brothersAndFriendsDisabled() {
                return !!this.params.interimAnswers;
            },
            positiveAnswersDisabled() {
                return this.params.positiveAnswers && !this.params.negativeAnswers;
            },
            negativeAnswersDisabled() {
                return this.params.negativeAnswers && !this.params.positiveAnswers;
            },
            stayIn100Available() {
                return this.params.difficult === 'Двузначные цифры' && !this.params.jumpOver;
            },
            stayIn1000Available() {
                return this.params.difficult === 'Трехзначные цифры' && !this.params.jumpOver;
            },
            interimAnswersDisabled() {
                return this.params.stayIn || !!this.params.jumpOver;
            },
            isAllowJumpOver() {
                return (
                    this.params &&
                    !this.params.combining &&
                    ((this.params.friends && this.params.friends.length > 0) ||
                        (this.params.brothersAndFriends && this.params.brothersAndFriends.length > 0)) &&
                    (this.params.difficult !== 'Однозначные цифры' || !this.params.negativeAnswers) &&
                    !this.params.fractions &&
                    !this.params.roundNumbers &&
                    !this.params.mirror
                );
            },
            secondsForSpeedUp() {
                return this.seconds.slice(0, this.seconds.indexOf(this.params.speed)).map(time => {
                    return {
                        time: time,
                        label: `${time} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds'),
                    };
                });
            },
            isPicturesAvailable() {
                return !this.gamesParameters || this.gamesParameters[this.slug]?.extraOptions.pictures;
            },
            isX2Available() {
                return (
                    (!this.gamesParameters || this.gamesParameters[this.slug]?.extraOptions.x2) &&
                    (!this.playersNumber || this.playersNumber === 1) &&
                    !this.params.dictation
                );
            },
            isMotionAvailable() {
                return (
                    (!this.gamesParameters || this.gamesParameters[this.slug]?.extraOptions.motion) &&
                    (!this.playersNumber || this.playersNumber === 1)
                );
            },
            isMusicAvailable() {
                return (
                    (!this.gamesParameters || this.gamesParameters[this.slug]?.extraOptions.music) &&
                    (!this.playersNumber || this.playersNumber === 1)
                );
            },
            isVoiceOverAvailable() {
                return (
                    this.gameMode === 'course' ||
                    (this.slug === 'AdditionAndSubtractionWithTime' &&
                        (!this.gamesParameters || this.gamesParameters[this.slug]?.extraOptions.voiceOver) &&
                        (!this.playersNumber || this.playersNumber === 1) &&
                        this.params &&
                        !DISABLED_VOICE_DIFFICULTIES.includes(this.params.difficult) &&
                        !this.params.fractions)
                );
            },
            availableTasksForComplication() {
                return [
                    ...Array(this.params.timeLimit ? this.examples + 1 : this.params.amountOfExamples).keys(),
                ].slice(1);
            },
            actions() {
                if (this.slug === 'AdditionAndSubtractionWithTime') {
                    return 99;
                }
                if (this.slug === 'AdditionAndSubtractionMathMagic') {
                    return 15;
                }
                return 14;
            },
            areBrothersOnlyOptionsDisabled() {
                return this.params && (!!this.params.interimAnswers || !this.params.brothers?.length);
            },
            areFriendsOnlyOptionsDisabled() {
                return (
                    this.params &&
                    (this.params.interimAnswers ||
                        (this.params.negativeAnswers &&
                            (!this.params.brothersAndFriends?.length ||
                                this.params.brothersAndFriendsOptions?.onlyAddition)) ||
                        !this.params.friends?.length)
                );
            },
            areBrothersAndFriendsOnlyOptionsDisabled() {
                return (
                    this.params &&
                    (this.params.interimAnswers ||
                        (this.params.negativeAnswers &&
                            (!this.params.friends?.length || this.params.friendsOptions?.onlyAddition)) ||
                        !this.params.brothersAndFriends?.length)
                );
            },
            isSpeedIncreaseDisabled() {
                let result =
                    (this.gamesParameters && this.gamesParameters[this.slug]?.isSpeedIncrease) ||
                    this.params.amountOfExamples <= 1 ||
                    this.params.speed <= 0.1;
                if (result) {
                    this.params.isSpeedIncrease = false;
                }
                return result;
            },
            isComplicationDisabled() {
                let result =
                    (this.gamesParameters && this.gamesParameters[this.slug]?.isComplication) ||
                    (this.params.amountOfExamples <= 1 && !this.params.timeLimit) ||
                    (this.params.amountOfActions >= 100 && this.slug === 'AdditionAndSubtractionWithTime') ||
                    (this.params.amountOfActions >= 15 && this.slug === 'AdditionAndSubtraction');
                if (result) {
                    this.params.isComplication = false;
                }
                return result;
            },
            showAnswerDurationHelpText() {
                return !this.params.answerDuration;
            },
            showNegativeAnswersHelpText() {
                return (
                    this.slug !== 'AdditionAndSubtractionMathMagic' &&
                    (this.params.negativeAnswers || this.params.interimAnswers) &&
                    ((!this.params.friends?.length && !this.params.brothersAndFriends?.length) ||
                        (!this.params.friends?.some(num => num !== 1) && !this.params.brothersAndFriends?.length))
                );
            },
            combiningDisabled() {
                return (
                    this.params &&
                    (this.params.difficult === 'Однозначные цифры' ||
                        this.params.mirror ||
                        (this.params.difficult === 'Двузначные цифры' && this.params.roundNumbers))
                );
            },
            formattedTimeLimitValues() {
                return this.timeLimitValues.map(amount => {
                    return {
                        amount: amount,
                        label: amount
                            ? `${amount} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_minutes')
                            : this.$i18n.t('trainer.trainer_gameFormSettingValue_off'),
                    };
                });
            },
            formattedSeconds() {
                if (this.slug === 'AdditionAndSubtraction') {
                    return this.seconds.map(time => {
                        return {
                            time: time,
                            label: time
                                ? `${time} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds')
                                : this.$i18n.t('trainer.trainer_gameFormSettingValue_off'),
                        };
                    });
                }
                return this.seconds
                    .filter(value => value !== 0)
                    .map(time => {
                        return {
                            time: time,
                            label: `${time} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds'),
                        };
                    });
            },
            tasksForSpeedUpOptions() {
                return [...Array(this.params.amountOfExamples).keys()].slice(1);
            },
            complicationOptions() {
                let sequenceLastNumber =
                    (this.slug === 'AdditionAndSubtraction' ? 16 : 101) - this.params.amountOfActions;
                return [...Array(sequenceLastNumber).keys()].slice(1);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .title {
        margin-bottom: 25px;
        display: flex;
        justify-content: center;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
    }
    .row {
        margin: 0;
    }
    .form-container {
        width: 100%;
        max-width: 1020px;
        margin: 0 auto;
    }
    .form-container__column {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        @media screen and (max-width: 767px) {
            flex-direction: column;
        }
    }
    .form-container__column_fixed {
        @media screen and (max-width: 767px) {
            flex-direction: row;
        }
        @media screen and (max-width: 575px) {
            flex-direction: row;
        }
    }
    .form-container__label {
        margin-right: 20px;
        width: 30%;
        text-align: right;
        @media screen and (max-width: 767px) {
            width: 100%;
            margin: 0 0 10px 0;
            text-align: left;
        }
    }
    .form-container__transition-through {
        width: auto;
    }
    .form-container__label_fixed {
        @media screen and (max-width: 767px) {
            margin-right: 20px;
            width: 100%;
            text-align: right;
        }
        @media screen and (max-width: 575px) {
            text-align: left;
            margin-right: 0;
        }
    }
    .input-label {
        @media screen and (max-width: 767px) {
            text-align: left;
        }
    }
    .form-container__select {
        width: 100%;
        max-width: 300px;
        @media screen and (max-width: 767px) {
            max-width: none;
        }
    }
    .form-container__select_spaced {
        @media screen and (max-width: 575px) {
            width: auto;
        }
    }
    .form-container__select_short {
        display: flex;
        align-items: center;
    }
    .form-container__select-examples {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        @media screen and (min-width: 700px) {
            flex-direction: row;
            align-items: center;
        }
    }
    .form-container__settings {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        margin-bottom: 40px;
    }
    .form-container__select-infinity-mode {
        display: flex;
        align-items: center;
        margin-top: 20px;
        @media screen and (min-width: 700px) {
            margin-top: 0;
        }
    }
    .form-container__checkbox {
        margin-left: 30px;
    }
    .form-container__svg-icon {
        opacity: 0.7;
        margin: 0 10px 10px 0;
    }
    .setting__checkbox {
        margin-right: 30px;
        @media screen and (max-width: 991px) {
            margin-bottom: 30px !important;
        }
        @media screen and (max-width: 575px) {
            margin-bottom: 40px !important;
        }
        @media screen and (max-width: 359px) {
            margin-right: 20px;
        }
    }
    .settings-header {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        margin-bottom: 20px;
    }
    .form-container__footer-buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        @media screen and (max-width: 767px) {
            flex-direction: column;
        }
    }
    .cancel-button {
        width: 200px;
    }
    .save-button {
        width: 200px;
        margin-left: 20px;
        @media screen and (max-width: 767px) {
            margin: 20px 0 0 0;
        }
    }
    .help-text {
        color: #888888;
    }
</style>
